<template>
  <button-component class="ViewerButton"
    :class="buttonClasses"
    :icon="icon"
    dark />
</template>

<script>
export default {
  name: 'ViewerButton',

  props: {
    icon: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * Classes for the button element
     * @return {Object}
     */
    buttonClasses () {
      return {
        'ViewerButton--isSmall': this.small
      }
    }
  }
}
</script>

<style>
@import 'properties';

.ViewerButton {
  width: 30px;
  height: 30px;
  background-color: var(--c-black-075);
  border-color: var(--c-grey-lt-075);

  @media (min-width: 1025px) {
    width: 42px;
    height: 42px;
  }
}

.ViewerButton--isSmall {
  width: 30px;
  height: 30px;
}

.ViewerButton:hover {
  background-color: var(--c-grey-lt);
  border-color: var(--c-grey-lt);
}

.ViewerButton svg {
  fill: var(--c-white) !important;
}

.ViewerButton .Icon {
  width: 16px !important;
  height: 16px !important;

  @media (min-width: 1025px) {
    width: 24px !important;
    height: 24px !important;
  }
}

.ViewerButton--isSmall .Icon {
  width: 16px !important;
  height: 16px !important;
}
</style>



// WEBPACK FOOTER //
// ViewerButton.vue?21ecc2b6